import React from "react";
import { EmployeeStatus, EmployeeStatusLabels } from "../../types/staff.types";

interface StaffStatusBadgeProps {
  status: EmployeeStatus | string;
  className?: string;
  onClick?: () => void;
}

export const StaffStatusBadge: React.FC<StaffStatusBadgeProps> = ({
  status,
  className = "",
  onClick,
}) => {
  const normalized = (status || "").toLowerCase();

  let styles = "bg-gray-50 text-gray-700 border-gray-200";
  let dotColor = "bg-gray-400";
  let label = status;

  if (normalized === EmployeeStatus.ACTIVE || normalized === "active") {
    styles = "bg-emerald-50 text-emerald-700 border-emerald-200";
    dotColor = "bg-emerald-500";
    label = EmployeeStatusLabels[EmployeeStatus.ACTIVE];
  } else if (normalized === EmployeeStatus.INACTIVE || normalized === "inactive") {
    styles = "bg-amber-50 text-amber-700 border-amber-200";
    dotColor = "bg-amber-500";
    label = EmployeeStatusLabels[EmployeeStatus.INACTIVE];
  } else if (normalized === EmployeeStatus.RESIGNED || normalized === "resigned") {
    styles = "bg-slate-100 text-slate-700 border-slate-200";
    dotColor = "bg-slate-500";
    label = EmployeeStatusLabels[EmployeeStatus.RESIGNED];
  } else if (normalized === EmployeeStatus.TERMINATED || normalized === "terminated") {
    styles = "bg-rose-50 text-rose-700 border-rose-200";
    dotColor = "bg-rose-500";
    label = EmployeeStatusLabels[EmployeeStatus.TERMINATED];
  }

  return (
    <span
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles} ${
        onClick ? "cursor-pointer hover:opacity-80 transition-opacity" : ""
      } ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
      {label}
    </span>
  );
};
